import { useMemo } from 'react'
import isEmpty from 'lodash/isEmpty'
import { css, cx, useTheme } from '@fable/theme'

import Slider, { SliderSettings } from '../../../../components/slider'
import { useTypedSelector } from '../../../../hooks'
import { Folio, FolioBook, Book as BookType } from '@fable/types'
import { Book } from '../books/book/Book'
import { Text } from '@fable/components'

interface Props {
  books: BookType[]
  config: SliderSettings
  customClass?: string
  hasControls: boolean
  folioData?: Folio
  labelClass?: string
  selectedFolioBook?: (book: BookType) => void
  sliderContainerClass?: string
  sliderWrapperClass?: string
  title: string
}

const BookSlider: React.FC<Props> = ({
  books,
  customClass = '',
  hasControls,
  folioData,
  labelClass = '',
  selectedFolioBook,
  sliderContainerClass = '',
  sliderWrapperClass = '',
  title,
  config,
}) => {
  const { purchasedBooks } = useTypedSelector(({ books }) => books)
  const { mediaQueries } = useTheme()

  const purchasedBookIds = useMemo(() => {
    return !isEmpty(purchasedBooks.data)
      ? new Set(
          Object.values(purchasedBooks.data).map((item) => {
            const book = item as BookType
            return book.id
          })
        )
      : null
  }, [purchasedBooks.data])

  const renderBooks = () => {
    return books
      .filter((item: BookType | FolioBook) => {
        const book = (item as FolioBook).book || item
        return book.authors.length > 0
      })
      .map((item: BookType | FolioBook) => {
        const bookData = (item as FolioBook).book || item
        const owned =
          !isEmpty(purchasedBookIds) && purchasedBookIds?.has(bookData.id)

        return (
          <Book
            book={bookData}
            folioData={folioData}
            isOwned={owned}
            key={bookData.id}
            selectedFolioBook={selectedFolioBook}
          />
        )
      })
      .filter(function (el) {
        return el != null
      })
  }

  return (
    <div className={`fds-ui--book-slider ${customClass}`}>
      <Text
        className={cx(
          css`
            padding-left: 24px;
            letter-spacing: -0.4px;
            ${mediaQueries.mobileL} {
              padding-left: 32px;
            }
          `
        )}
        tag="h2"
        type="header"
        sizing="XS"
        text={title}
      />
      <Slider
        hasControls={hasControls}
        config={config}
        wrapperClass={cx(styles.slider, sliderWrapperClass)}
        containerClass={sliderContainerClass}
        itemCount={books.length}
        compact
      >
        {renderBooks()}
      </Slider>
    </div>
  )
}

export default BookSlider

const styles = {
  slider: css`
    position: relative;
  `,
}
